export default {
  capitalRaise: 'CapitalRaise',
  partialSale: 'PartialSale',
  fullSale: 'FullSale',
  interventionFund: 'InterventionFund',
};
